export enum NewsActionTypes {
  GET_NEWS_PENDING = '@@news/GET_NEWS_PENDING',
  GET_NEWS_SUCCESS = '@@news/GET_NEWS_SUCCESS',
  GET_NEWS_ERROR = '@@news/GET_NEWS_ERROR'
}
